module.exports = __webpack_public_path__ + "img/txsb_qr.4cb7ceac.png";